// extracted by mini-css-extract-plugin
module.exports = {"RippleEffect__Container":"RippleEffect_RippleEffect__Container__TxQSS","RippleEffect__Circle":"RippleEffect_RippleEffect__Circle__3wEty","ripple":"RippleEffect_ripple__3z90M"};